// @auto-index

import icon from './icon.jpg'

export { default as icon } from './icon.jpg'

export default {
  icon
}
